import { toJpeg } from "html-to-image";

class makeIMG {
  async _init(id, targetId) {
    // const container = document.getElementById(id);
    // const targetContainer = document.getElementById("targetForGeneratedImg");
    // toJpeg(container, { quality: 0.95, useCORS: true }).then((dataUrl) => {
    //   targetContainer.src = dataUrl;
    // });

    const container = document.getElementById(id);
    const images = container.getElementsByTagName("img");

    await Promise.all(
      Array.from(images).map((img) => {
        return new Promise((resolve) => {
          if (img.complete) resolve();
          else img.onload = resolve;
        });
      })
    );

    toJpeg(container, {
      quality: 0.95,
      useCORS: true,
      imageRendering: "pixelated",
    }).then((dataUrl) => {
      document.getElementById("targetForGeneratedImg").src = dataUrl;
    });
  }
}

export default new makeIMG();
